module.exports = __webpack_public_path__ + "static/media/map.182e6278.jpg";